import { render, staticRenderFns } from "./centerCollection.vue?vue&type=template&id=5ed4fa47&scoped=true&"
import script from "./centerCollection.vue?vue&type=script&lang=js&"
export * from "./centerCollection.vue?vue&type=script&lang=js&"
import style0 from "./centerCollection.vue?vue&type=style&index=0&id=5ed4fa47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed4fa47",
  null
  
)

export default component.exports